import React from "react";
import { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
//import Table from "./Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faPen,
  faTimes,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import Popup from "reactjs-popup";
import { PopupMessage, InfoPopupMessage } from "../../utils/utils";
import axios from "axios";
import { clientAccess } from "../../utils/index";
import "bootstrap/dist/css/bootstrap.css";
import apiUrl from "../../apiUrlConstant";
import CreatableSelect from "react-select/creatable";
import DatePicker from "react-datepicker";
import { Redirect, withRouter, Link } from "react-router-dom";
import Select from "react-select";
import TopHeader from "../../layout/TopHeader";
import SimpleReactValidator from "simple-react-validator";
import ValuationTable from "./ValuationTable";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

const YearArr = [];
for (var i = 2000; i <= 2025; i++) {
  YearArr.push(i)
}

class Valuation extends React.Component {
  state = {
    counter: Math.random(),
    LandlordGroups: [],
    clientList: [],
    value: [],
    redirect: false,
    popupContent: "",
    messsagePopup: false,
    delete: false,
    disableOnEdit: false,
    delete: false,
    currentIndex: null,
    assets: [],
    month: "",
    year: "",
    asset_value: "",
    showFirstAddBtn: true,
    // YearArr:[],
    Deals: [],
    url: `${apiUrl.apiUrl.url}/close-deal/create-valuation/`,
    id: undefined,
    month: '',
    initialValues: {
      groupId: "",
      groupName: "",
      clientId: "",
      clientName: "",
      asset_name: "",
      assetId: "",
      asset_type: "",
      deal_type: "",
      month: "",
      year: "",
      asset_value: "",
      value: ""
    },
  };

  resetForm(values) {
    this.state.initialValues = {};

    values.groupId = "";
    values.groupName = "";
    values.clientId = "";
    values.clientName = "";
    values.asset_name = "";
    values.asset_type = "";
    values.asset_value = "";
    values.valuationMM = "";
    values.valuationYY = "";
    values.asset_value = "";
    values.month = "";
    values.year = "";
    values.assetId = "";
    values.showFirstAddBtn = true;
    this.setState({});
  }

  constructor(props) {
    super(props);
    this.mainFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
    });

  }


  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/client-group/fetch-list`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          LandlordGroups: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });


    fetch(`${apiUrl.apiUrl.url}/countries`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  complianceList = (clientId, id) => {
    var ths = this;
    fetch(
      `${apiUrl.apiUrl.url}/compliance/get-list-asset?client_id=${clientId}&id=${id}`,
      {headers}
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data, "compliance data");
        // this.setState({
        //   assetCompliance: data.data,
        // });
        ths.state.initialValues.assetCompliance = data.data;
        ths.state.compliance_count = data.count;
        ths.state.compliance_percent = data.percent_count;
        ths.setState({});
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getValuationDetails = (id) => {
    fetch(
      `${apiUrl.apiUrl.url}/close-deal/fetch-valuation-details?id=${id}`,
      {headers}
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data.data, "data.data");
        this.setState({
          url: `${apiUrl.apiUrl.url}/close-deal/update-valuation?id=${id}`,
          initialValues: data.data,
        });

        //this.state.year = { 'value' : data.data.year, 'label':  data.data.year }
        //this.state.month = { 'value' : data.data.month, 'label':  data.data.month }
        this.setState({});
        console.log(this.state.initialValues, "initial values");
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getCityId(e) {
    this.state.cityId = e.target.value;
  }

  checkDelete() {
    var self = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/close-deal/check-delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        self.setState({
          messsagePopup: true,
          popupContent: "Sorry you cannot delete this deal",
        });
      } else {
        self.setState({
          delete: true,
        });
      }
    });
  }


  componentDidUpdate() {
    if (this.props.match.params.id != this.state.id) {
      this.state.id = this.props.match.params.id;
      if (this.props.match.params.id === undefined) {
        this.setState({
          url: `${apiUrl.apiUrl.url}/close-deal/create-valuation`,
          initialValues: {
            groupId: "",
            groupName: "",
            clientId: "",
            clientName: "",
            asset_name: "",
            assetId: "",
            asset_type: "",
            month: '',
            year: '',
            deal_type: "",
          },
        });
      } else {
        this.loadAssetDetails();
      }
    }
  }

  loadAssetDetails = () => {
    fetch(
      `${apiUrl.apiUrl.url}/close-deal/fetch-valuation-details?id=${this.props.match.params.id}`,
      {headers}
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data.data, "data.data");
        this.setState({
          //url: `${apiUrl.apiUrl.url}/close-deal/update-valuation?id=${this.props.match.params.id}`,
          url: `${apiUrl.apiUrl.url}/close-deal/create-valuation?id=${this.props.match.params.id}`,
          initialValues: data.data,
        });
        this.initialValues.state.year = { 'value': '', 'label': '' }
        this.initialValues.state.month = { 'value': '', 'label': '' }
        this.setState({});
      })
      .catch((error) => {
        console.log(error);
      });
  }

  redirectToDelete = () => {
    this.setState({ delete: false });
    var ths = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/close-deal/delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        ths.setState({
          messsagePopup: true,
          popupContent: "Something Went Wrong",
        });
      } else {
        ths.setState({
          messsagePopup: true,
          popupContent: "Data Deleted Successfully",
        });
      }
    });
  };
  redirectToClose = () => {
    this.setState({ delete: false });
  };

  resetCounter = () => {
    this.setState({ counter: Math.random() });
  }

  redirectAfterSave = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      initialValues: {
        groupId: "",
        groupName: "",
        clientId: "",
        clientName: "",
        asset_name: "",
        assetId: "",
        asset_type: "",
        deal_type: "",
        asset_value: "",
        month: "",
        year: "",
      },
    });
    this.loadAssetDetails();
  };

  redirectAfterEdit = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      initialValues: {
        groupId: "",
        groupName: "",
        clientId: "",
        clientName: "",
        asset_name: "",
        assetId: "",
        asset_type: "",
        asset_value: "",
        month: "",
        year: "",


        // deal_type: "",
      },
    });
    this.loadAssetDetails();
  };


  infoClose = () => {
    this.setState({
      redirect: false,
      messsageInfoPopup: false
    });
  }

  handleChangeLandlordGroup = (newValue, actionMeta) => {
    console.group("Value Changed", newValue, "actionMeta", actionMeta);

    if (actionMeta == "change_client_group") {
      this.state.initialValues.groupId = newValue.value;
      this.state.initialValues.groupName = newValue.label;

      fetch(`${apiUrl.apiUrl.url}/client/client-list?groupId=` + newValue.value, {headers})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            clientList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

      console.log("inside", actionMeta);
    } else {
      this.state.initialValues.clientId = newValue.value;
      this.state.initialValues.clientName = newValue.label;

      this.complianceList(newValue.value, this.state.initialValues.assetId);
    }
    this.setState({});
    //this.state.initialValues.groupName = newValue.label;

    this.groupId = newValue;
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to={"/close-deals/valuation/" + this.props.match.params.id} />;
    }
    return (

      <div className="parentContainer">
        <>
          <div className="absoluteItemForTopBar">
            <div className="new_breadcrumbs_design">
              <ul className="d-flex align-items-center gap-3 p-0 m-0">
                <li><Link to="/close-deals">Close Deals</Link></li>
                <li><FontAwesomeIcon icon={faChevronRight} /></li>
                <li>
                  <a href="#">Valuation</a>
                </li>
              </ul>
            </div>
          </div>

          <Formik
            initialValues={this.state.initialValues}
            enableReinitialize
            onSubmit={(values, actions) => {
              if (!this.mainFormValidator.allValid()) {
                this.mainFormValidator.showMessages();
                return false;
              }
              values.assetTypeId = this.state.initialValues.assetTypeId;
              values.assetId = this.state.initialValues.assetId;
              var self = this;
              axios({
                method: "post",
                url: this.state.url,
                data: values,
              }).then(function (response) {
                if (!response.data.success) {
                  actions.setSubmitting(false);
                  actions.setErrors(response.data);
                } else {
                  self.state.initialValues.asset_type = values.asset_type;
                  self.state.initialValues.asset_name = values.asset_name;
                  self.setState({
                    url: `${apiUrl.apiUrl.url}/close-deal/create-valuation?id=${self.props.match.params.id}`,
                    messsagePopup: true,
                    popupContent: "Data Saved Successfully!",
                  });
                  self.setState({});
                }
              });
            }}
          >
            {
              ({
                values,

                errors,

                touched,

                handleChange,

                handleBlur,

                handleSubmit,

                isSubmitting,
              }) => (
                <>
                  <div className="unitFormContainerNew">
                    <Form autoComplete="off" >
                      <div className="newGridSectionParent">
                        <div className="newGridSectionForFormMain">

                          {/* Asset Type */}
                          <div className="newGridSectionInner">
                            <label>
                              Asset Type <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field type="text" readOnly name="asset_type" />
                              <ErrorMessage
                                name="asset_type"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          {/* Asset Name */}
                          <div className="newGridSectionInner">
                            <label>
                              Asset Name <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field type="text" readOnly name="asset_name" />
                              <ErrorMessage
                                name="asset_name"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          {/* Month/Year */}
                          <div className="newGridSectionInner">
                            <label>
                              Month/Year
                            </label>
                            <div className="position-relative">
                              <div className="row m-0">
                                <div className="col-sm-6 ps-0 dueDateFieldWidth">
                                  <div className="position-relative">
                                    <Field as="select" name="month" onChange={handleChange}>
                                      <option value="">Select</option>
                                      <option value="January">January</option>
                                      <option value="February">February</option>
                                      <option value="March">March</option>
                                      <option value="April">April</option>
                                      <option value="May">May</option>
                                      <option value="June">June</option>
                                      <option value="July">July</option>
                                      <option value="August">August</option>
                                      <option value="September">September</option>
                                      <option value="October">October</option>
                                      <option value="November">November</option>
                                      <option value="December">December</option>
                                    </Field>
                                    <ErrorMessage
                                      name="month"
                                      component="div"
                                      className="text-red"
                                    />
                                  </div>
                                </div>
                                <div className="col-sm-6 pe-0 dueDateFieldWidth">
                                  <div className="position-relative">
                                    <Field as="select" name="year" onChange={handleChange}>
                                      <option value="">Select</option>
                                      {YearArr.map(year => (
                                        <option key={year} value={year}>
                                          {year}
                                        </option>
                                      ))}
                                    </Field>
                                    <ErrorMessage
                                      name="year"
                                      component="div"
                                      className="text-red"
                                    />
                                  </div>
                                </div>
                                <div className="col-sm-12 p-0 mt-3">
                                  <Field type="number" name="asset_value" />
                                  <ErrorMessage
                                    name="asset_value"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                        {this.props.match.params.id !== undefined ? (
                          <div className="newGridSectionInner button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                            <button type="submit" className="add_button" disabled={isSubmitting}>
                              Add
                            </button>
                            {/* Delete button commented out */}
                            <button type="reset" className="reset_button" onClick={this.redirectAfterEdit}>
                              {/* Reset link commented out */}
                              Reset
                            </button>
                          </div>
                        ) : (
                          <div className="newGridSectionInner button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                            <button type="submit" disabled={isSubmitting}>
                              Add
                            </button>
                            <button type="reset">
                              <Link
                                to="/close-deals/valuation"
                                onClick={(e) => {
                                  this.resetForm(values);
                                }}
                              >
                                Reset
                              </Link>
                            </button>
                          </div>
                        )}


                      </div>
                    </Form>
                  </div>
                </>
              )}
          </Formik>
          <PopupMessage
            open={this.state.messsagePopup}
            content={this.state.popupContent}
            redirectAfterSave={this.redirectAfterSave}
          />
          <InfoPopupMessage
            open={this.state.messsageInfoPopup}
            content={this.state.popupInfoContent}
            infoClose={this.infoClose}
            infoOk={this.infoClose}
          />
          <Popup open={this.state.delete} position="top center">
            {(close) => (
              <div>
                "Delete the item?"
                <a className="close" onClick={this.redirectToClose}>
                  &times;
                </a>
                <div>
                  <button type="button" onClick={this.redirectToDelete}>
                    Yes
                  </button>
                </div>
              </div>
            )}
          </Popup>
          <ValuationTable key={this.state.counter} deal_id={this.props.match.params.id} ths={this} />
        </>
      </div>

    );
  }
}

export default withRouter(Valuation);